var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectedSatelliteNumber)?_c('div',{attrs:{"id":"map"}},[_c('map-tools',{staticClass:"fixed-bottom text-right pr-2 pb-2 pb-md-0",attrs:{"id":"map-tools"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }